var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"confluence-oauth-callback"},[(_setup.success)?_c('p',[_vm._v("Confluence connected successfully. This window will close automatically.")]):(_setup.errorMessage)?_c('p',{staticClass:"confluence-oauth-callback__error"},[_vm._v(_vm._s(_setup.errorMessage))]):_c('p',[_vm._v("Processing...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }